export const PLAN_FEATURES = [
  'Unlimited presentations & PPTX downloads',
  'AI image & infographic generation, web serch',
  'Unlimited access to premium templates, fonts & icons',
  'Custom logo & branding',
];

export const PAYMENT_METHODS = [
  { id: 'card', name: 'Credit or Debit Card', subtitle: 'Visa, Mastercard, Amex, UnionPay' },
  { id: 'paypal', name: 'PayPal', subtitle: 'Pay with your PayPal account' },
  {
    id: 'wallets',
    name: 'Wallets',
    subtitle: 'Apple Pay, Google Pay, Cash App Pay, Link, and others',
  },
];
